import { BackgroundColorSystemPropValue, GridItem } from '@coolblue-development/freddy';
import { pageTemplateColumns } from '@styles/gridTemplates';
import React from 'react';

export const PageRow = ({
  children,
  backgroundColor,
  withContainer = false
}: {
  children: React.ReactNode;
  backgroundColor?: BackgroundColorSystemPropValue;
  withContainer?: boolean;
}) => (
  <GridItem
    column='1/-1'
    backgroundColor={backgroundColor}
    sx={{ display: 'grid', gridTemplateColumns: pageTemplateColumns }}
  >
    {withContainer ? (
      <GridItem
        column={2}
        padding={{ xs: '2.4rem 1.2rem', md: '3.2rem' }}
        backgroundColor='base'
        sx={{
          borderRadius: '16px'
        }}
      >
        {children}
      </GridItem>
    ) : (
      <GridItem column={2}>{children}</GridItem>
    )}
  </GridItem>
);
